import React, { useCallback } from 'react';
import classNames             from 'classnames';

import { addFileExtension } from '../../../../../common/tools/getFileExtension';

const renderDownloadableCardBlock = function(data, index) {
  const {
          ALT,
          BACKGROUND_COLOR,
          BUTTON = '',
          CONTENT,
          IMAGE  = [],
          FILE,
          FILE_LINK,
        }     = data;
  const [img] = IMAGE;

  const handleDownload = () => {
    if ((!BUTTON.trim().length && !!FILE.length) || FILE_LINK) {
      const link = document.createElement('a');

      link.href     = FILE_LINK || addFileExtension(...FILE);
      link.download = '';
      link.target   = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <section key={index} style={{ backgroundColor: BACKGROUND_COLOR }}>
      <div className={'container'}>
        <div
          className={classNames('downloadable_card', { downloadable: !BUTTON.trim().length && !!FILE.length })}
          onClick={handleDownload}
        >
          <picture>
            {!(img?.endsWith('.svg') || img?.endsWith('.gif')) ? (
              <>
                <source srcSet={addFileExtension(...IMAGE, '.webp')} type={'image/webp'} />
                <source srcSet={addFileExtension(...IMAGE)} type={'image/png'} />
                <img src={addFileExtension(...IMAGE)} alt={ALT} />
              </>
            ) : (
              <img src={img} alt={ALT} />
            )}
          </picture>
          {((!!BUTTON.trim().length && !!FILE.length) || FILE_LINK) && (
            <a
              className={'download_btn'}
              download
              href={FILE_LINK || addFileExtension(...FILE)}
              target={'_blank'}
            >
              {BUTTON}
            </a>
          )}
          <div dangerouslySetInnerHTML={{ __html: CONTENT }} />
        </div>
      </div>
    </section>
  );
};

export default renderDownloadableCardBlock;